import PaymentItem from './PaymentItem';

export default PaymentItem;
